import cn from 'classnames';

import { setJumpLinkAttributes } from 'src/utils/jumpLinks';

import { ImageData, JumpLinkLabel, LinkData } from 'src/types/components';

import Cta from 'components/BaseHelpers/Cta';
import Image from 'components/BaseHelpers/Image';
import RichText from 'components/BaseHelpers/RichText';
import Text from 'components/BaseHelpers/Text';

import PatternBackground from '../PatternBackground';

import styles from './CtaSection.module.scss';

export type CtaSectionProps = {
  eyebrow: string;
  heading: string;
  description: string;
  image?: ImageData;
  link: LinkData;
} & JumpLinkLabel;

const CtaSection = (props: CtaSectionProps): JSX.Element => {
  const { image, description, eyebrow, heading, link, jumpLinkLabel } = props;

  if (!description && !heading) {
    return <></>;
  }

  return (
    <div
      className={cn(styles.main)}
      {...setJumpLinkAttributes(jumpLinkLabel)}
      data-component="CtaSection"
    >
      <div className={styles.bg}>
        <PatternBackground className={styles.pattern} size="medium" theme="light" />
      </div>
      <div className={cn(styles.wrapper, 'container-10')}>
        {image && (
          <div className={styles['image-wrapper']}>
            <Image className={styles.image} src={image.src} alt={image.alt} fill />
          </div>
        )}
        <div className={cn(styles.content)}>
          <Text className="body-eyebrow" field={eyebrow} />
          <Text tag="h2" className="heading-h3" field={heading} />
          <div
            className={cn(styles.body, {
              [styles['body--long-cta']]: link && link.label && link.label.length > 14,
            })}
          >
            <RichText className="body-med" field={description} />
            {link && link.href && link.label && (
              <Cta
                tag="a"
                href={link.href}
                openNewTab={link.target === '_blank'}
                className={cn(styles.cta)}
              >
                {link.label}
              </Cta>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CtaSection;
